<template>
    <v-text-field

        @change="setValue"
        type="tel"
        @input="setValue($event,true)"
        @click:append="setValue(Number(value) + step)"
        @click:prepend-inner="setValue(Number(value) - step)"
        v-bind="{...$attrs,...$props,class:''}"
        :prepend-inner-icon="'mdi-minus'"
        :append-icon="'mdi-plus'"
        class="text-field-numeric"


    ></v-text-field>
</template>

<script>
export default {
    name    : "VVStepNumber",
    props   : {
        'value'  : null,
        'max'    : {
            type   : Number,
            default: Number.MAX_SAFE_INTEGER
        }, 'min' : {
            type   : Number,
            default: Number.MIN_SAFE_INTEGER
        }, 'step': {
            type   : Number,
            default: 1
        }
    },
    methods : {
        setValue(newVal, noRange) {
            let filteredNewVal = String(newVal).replace(/\D/g, '');
            filteredNewVal -= Number(filteredNewVal) % this.step
            if (!noRange)
                filteredNewVal = Math.max(Math.min(this.max, filteredNewVal), this.min);
            if (newVal != filteredNewVal && filteredNewVal == this.value) {
                this.$emit('input', String(filteredNewVal) + ' ');
            }

            this.$nextTick(function () {
                this.$emit('input', String(filteredNewVal));
            });


        }
    },
    watch   : {},
    computed: {
        mask() {
            return '#'.repeat(String(this.max).length)
        }
    }
}
</script>

<style scoped>
.text-field-numeric {
    max-width: 150px !important;
}

.text-field-numeric >>> input {
    text-align: center;
}

.text-field-numeric >>> .v-text-field__slot label {
    left: -27px !important;
    overflow: visible;
}
</style>
